var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_228_7677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.23066 11.3295C8.23066 11.6608 8.49929 11.9295 8.83066 11.9295C9.16203 11.9295 9.43066 11.6608 9.43066 11.3295L9.43066 4.4386L11.7945 6.94144C12.022 7.18235 12.4017 7.1932 12.6426 6.96568C12.8835 6.73815 12.8944 6.3584 12.6669 6.11749L9.26687 2.51749C9.15353 2.39748 8.99574 2.32947 8.83066 2.32947C8.66559 2.32947 8.5078 2.39748 8.39446 2.51749L4.99446 6.11749C4.76693 6.3584 4.77778 6.73815 5.01869 6.96567C5.2596 7.1932 5.63934 7.18235 5.86687 6.94144L8.23066 4.4386L8.23066 11.3295Z",
    fill: "#050920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.63066 10.9295C3.63066 10.5981 3.36203 10.3295 3.03066 10.3295C2.69929 10.3295 2.43066 10.5981 2.43066 10.9295V12.9295C2.43066 14.1445 3.41564 15.1295 4.63066 15.1295H13.0307C14.2457 15.1295 15.2307 14.1445 15.2307 12.9295V10.9295C15.2307 10.5981 14.962 10.3295 14.6307 10.3295C14.2993 10.3295 14.0307 10.5981 14.0307 10.9295V12.9295C14.0307 13.4818 13.5829 13.9295 13.0307 13.9295H4.63066C4.07838 13.9295 3.63066 13.4818 3.63066 12.9295V10.9295Z",
    fill: "#050920"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_228_7677"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.830566 0.729492)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.148a6a82c8a9bb3a921f5d6b0e1469c5.svg";
export { ForwardRef as ReactComponent };